import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = "https://cnxrqxfjpyqukyzijggo.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNueHJxeGZqcHlxdWt5emlqZ2dvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc1MDE2NTMsImV4cCI6MjA2MzA3NzY1M30.6oFvkG0OwISq31O7D3b2SLcTDDBlfxN7m4WLCrdqNKg";
export const TABLE = "atp_elo_ratings";
export const CLOUD_RUN_WEBHOOK_URL = "https://scraper-api-980976931719.europe-west1.run.app/webhook";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY); 